const DEFAULT_FALLBACK = '';

export function i18nText(currentLocale, texts, name) {
  const value = texts.find((text) =>
    text.language_code == currentLocale && text.name == name
  );
  return value ? value.content : DEFAULT_FALLBACK;
}